<template>

    <div class="card mt-3">
        <div class="card-header bg-primary text-white">
            <div class="float-left">  {{ header }} </div>
            <div class="float-right"> Bestellung: {{ getCurrentOrderId }} </div>
        </div>
        <div class="card-header bg-default xPadding">
            <i class="fas fa-arrow-circle-right"></i> <b></b> {{ reason }}
        </div>

        <div class="card-body" style="min-height: 300px">

            <slot></slot>

        </div>

        <div class="card-footer">
            <button v-if="btnAbbortName" @click="$emit('abbort')"   class="float-left btn btn btn-warning visible-xs-block visible-sm-block">{{ btnAbbortName }}</button>
            <button v-if="btnDoneName" @click="$emit('stepdone')" class="float-right btn btn btn-success visible-xs-block visible-sm-block">{{ btnDoneName }} <i class="fas fa-arrow-alt-circle-right"></i> </button>
        </div>

    </div>

</template>

<script>
    export default {
        name: "wizard-step-card",

        data: () => ({
            showShoppingcart: false
        }),

        props: {
            header: {
                type: String,
                required: true
            },

            reason: {
                type: String,
                required: true
            },

            btnDoneName: {
                type: String|Boolean,
                default: 'Nächster Schritt'
            },

            btnAbbortName: {
                type: String|Boolean,
                default: 'Abbrechen'
            }
        },

        computed: {

            getCurrentOrderId () {
                return this.$store.getters.getCurrentOrderId
            }
        }
    }
</script>

<style scoped>
    .xPadding { padding: 10px 20px; font-size: 0.9em }

</style>